import React from "react";
import "./AnimatedBackground.scss";

const AnimatedBackground = () => {
  return (
    <div id="particle-container">
      {Array.from({ length: 30 }).map((_, index) => (
        <div className="particle" key={index}></div>
      ))}
    </div>
  );
};

export default AnimatedBackground;
